module.exports = __webpack_public_path__ + "img/普通会员.95ad76f5.png";